<div class="page-section">
  <div class="sales-channels-dashboard-head">
    <reb-ngx-heading-label color="#15245A" size="h3" weight="500">Sales Channels Activity
      <reb-ngx-heading-label color="#15245A" size="h5" weight="400">( Last 7 Days )</reb-ngx-heading-label>
    </reb-ngx-heading-label>
  </div>
  <div *ngIf="isChannelsReady" class="page-section-body border noborder-important">
    <!-- No Channels Message -->
    <reb-ngx-banner *ngIf="isChannelError" mood="error" message="There was an error when trying to retrieve sales channels."></reb-ngx-banner>
    <reb-ngx-banner *ngIf="!isChannelError && collectionOfChannels.length === 0" mood="info" message="No Channels found."></reb-ngx-banner>

    <!-- Sales Channels Content -->
    <div *ngIf="!isChannelError && collectionOfChannels.length > 0" class="page-section-body border noborder-important">
      <div class="mat-list mat-list-base custom-mat-list sales-channels-section-wrapper">
        <reb-ngx-card *ngFor="let channel of collectionOfChannels"
          [showHeader]="true" width="size1of1" class="sales-channels-card">
        <div card-header-title>
          <reb-ngx-heading-label mood="default" size="h3" weight="500">{{channel.integrationName | titlecase}}</reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <div class='row card-row'>
            <div class='col card-row-item'>
              <reb-ngx-heading-label mood="none" size="h6" weight="400" class="card-row-item-label">Store:</reb-ngx-heading-label>
            </div>
            <div class='col card-row-item'>
              <reb-ngx-label mood="default" size="14" weight="500" class="card-row-item-label">
                {{channel.displayName}}
              </reb-ngx-label>
            </div>
          </div>
          <div class='row card-row'>
            <div class='col card-row-item' >
              <reb-ngx-heading-label mood="none" size="h6" weight="400" class="card-row-item-label">Customers:</reb-ngx-heading-label>
            </div>
            <div class='col card-row-item'>
              <reb-ngx-label mood="default" size="14" weight="500" class="card-row-item-label">
                {{channel.customerCount}}
              </reb-ngx-label>
            </div>
          </div>
          <div class='row card-row'>
            <div class='col card-row-item'>
              <reb-ngx-heading-label mood="none" size="h6" weight="400" class="card-row-item-label">Subscription:</reb-ngx-heading-label>
            </div>
            <div class='col card-row-item'>
              <reb-ngx-label mood="default" size="14" weight="500" class="card-row-item-label">
                {{channel.subscriptionCount}}
              </reb-ngx-label>
            </div>
          </div>
          <div class='row card-row'>
            <div class='col card-row-item'>
              <reb-ngx-heading-label mood="none" size="h6" weight="400" class="card-row-item-label">Invoices:</reb-ngx-heading-label>
            </div>
            <div class='col card-row-item'>
              <reb-ngx-label mood="default" size="14" weight="500" class="card-row-item-label">
                {{channel.invoiceCount}}
              </reb-ngx-label>
            </div>
          </div>
          <div class='row card-row'>
            <div class='col card-row-item'>
              <reb-ngx-heading-label mood="none" size="h6" weight="400" class="card-row-item-label">Revenue:</reb-ngx-heading-label>
            </div>
            <div class='col card-row-item'>
              <reb-ngx-label mood="default" size="14" weight="500" class="card-row-item-label">
                {{companyCurrencyBase?.currency?.symbol}}{{channel.invoiceAmount}}
              </reb-ngx-label>
            </div>
          </div>
        </div>
        </reb-ngx-card>
      </div>
    </div>
  </div>
  <div *ngIf="!isChannelsReady" class="page-section-body border noborder-important">
    <div class="page-section-body border noborder-important">
      <div class="mat-list mat-list-base custom-mat-list sales-channels-section">
        <reb-ngx-card [showHeader]="false" width="size1of1" class="sales-channels-card">
        <div card-header-title>
          <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
        </div>
        <div class="card-body-content">
          <div class='row'>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
          <div class='row '>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
          <div class='row'>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
          <div class='row'>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
        </div>
        </reb-ngx-card>
        <reb-ngx-card [showHeader]="false" width="size1of1" class="sales-channels-card">
          <div card-header-title>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
          <div class="card-body-content">
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row '>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
          </div>
        </reb-ngx-card>
        <reb-ngx-card [showHeader]="false" width="size1of1" class="sales-channels-card">
          <div card-header-title>
            <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
          </div>
          <div class="card-body-content">
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row '>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
            <div class='row'>
              <skeleton-loader [theme]="{'width': '100%'}"></skeleton-loader>
            </div>
          </div>
        </reb-ngx-card>
      </div>
    </div>
  </div>
</div>
